import React, { useState, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { Link, Navigate } from "react-router-dom";
import { Box, TextField, Button, Typography, Alert } from "@mui/material";
import { FirebaseAuth } from "../../../components/FirebaseAuth/firebase";
import { AuthContext } from "../../../components/FirebaseAuth";
import AuthLayout from "../../../components/AuthLayout";

const ForgotPassword = () => {
    const { t } = useTranslation();
    const { authUser } = useContext(AuthContext);

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    if (authUser.checked && authUser.user) {
        return <Navigate to="/" replace />;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await FirebaseAuth.auth().sendPasswordResetEmail(email);
            setSent(true);
        } catch (err) {
            setError(err.message);
        }
        setLoading(false);
    };

    return (
        <AuthLayout>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, textAlign: 'center' }}>
                {t('auth.forgotTitle')}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
                {t('auth.forgotSubtitle')}
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            {sent ? (
                <Box>
                    <Alert severity="success" sx={{ mb: 3 }}>
                        {t('auth.resetEmailSent')}
                    </Alert>
                    <Typography variant="body2" sx={{ textAlign: 'center' }}>
                        <Link to="/signin" style={{ textDecoration: 'none' }}>{t('auth.backToSignIn')}</Link>
                    </Typography>
                </Box>
            ) : (
                <>
                    <Box component="form" id="forgot-password-form" name="forgot-password" onSubmit={handleSubmit} noValidate>
                        <TextField
                            label={t('auth.workEmail')}
                            type="email"
                            fullWidth
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            sx={{ mb: 3 }}
                            autoComplete="email"
                            autoFocus
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            size="large"
                            disabled={loading || !email}
                            sx={{ mb: 3, textTransform: 'none', fontWeight: 600 }}
                        >
                            {loading ? t('auth.sending') : t('auth.sendResetLink')}
                        </Button>
                    </Box>
                    <Typography variant="body2" sx={{ textAlign: 'center' }}>
                        <Link to="/signin" style={{ textDecoration: 'none' }}>{t('auth.backToSignIn')}</Link>
                    </Typography>
                </>
            )}
        </AuthLayout>
    );
};

export default ForgotPassword;
